import React from "react";
import styles from "./SecondaryTooltip.module.scss";

const SecondaryTooltip = ({ children, toolTipMsg }) => {
  return (
    <div className={styles.tooltip}>
      {children}
      <div className={styles.tooltipText}>{toolTipMsg}</div>
    </div>
  );
};

export default SecondaryTooltip;
